import { render, staticRenderFns } from "./organization-users.vue?vue&type=template&id=23c1f781&scoped=true"
import script from "./organization-users.vue?vue&type=script&lang=js"
export * from "./organization-users.vue?vue&type=script&lang=js"
import style0 from "./organization-users.vue?vue&type=style&index=0&id=23c1f781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1f781",
  null
  
)

export default component.exports